import * as yup from 'yup';

export const schemaSearch = yup.object().shape({
  search: yup.string().nullable().max(255, ' '),
});
